<script>
  import DropDown from '../components/DropDown.svelte';
  let objCurrentList;
  import AssignTaskList from '../components/AssignTask/AssignTaskList.svelte';
  import Select from 'svelte-select';
  import TabRegistrationType from '../components/AssignTask/TabRegistrationType.svelte';
  import AssignTaskFilter from '../components/AssignTask/AssignTaskFilter.svelte';
  import { onMount } from 'svelte';
  import { client } from 'root/api/index.js';

  import { getContext, setContext, onDestroy } from 'svelte';
  import AssignTaskSubFilter from 'components/AssignTask/AssignTaskSubFilter.svelte';
  setContext('taskAction', (params) => {
    if (addTaskModal != undefined) {
      addTaskModal.hide();
    }
  });
  const addTask = () => {
    id = 0;
    addTaskModal = new Modal(document.getElementById('addTaskModal'), {
      keyboard: false,
    });
    addTaskModal.show();
  };

  let formLoading = false;
  let filter = true;
  let extraFilter = {
    recurring: 0,
    recurringCheck: false,
    unitId: 1,
    clientId: 2,
    taskType: 1,
    taskSubType: 1,
    clientTypes: [],
    recurringTypes: [],
    registrationTypes: [],
    projectTypes: [],
    clientFundProfile: [],
    unitUsers: [],
    comeFrom: 'assignTask',
  };
  let projectTypes = [];
  let clientTypes = [];
  let registrationTypes = [];
  let fundProfiles = [];
  let selectedTasks = [];

  const getClientDetail = () => {
    if (extraFilter.unitId > 0) {
      formLoading = true;
      if (extraFilter.clientId > 0) {
        client.getClientMasterData({ id: extraFilter.clientId }).then((result) => {
          let unitMasterData = result.data;
          clientTypes = unitMasterData.clientTypes;
          projectTypes = unitMasterData.projectTypes;
          registrationTypes = unitMasterData.registrationTypes;
          // fundProfiles=unitMasterData.fundProfiles;

          extraFilter = {
            ...extraFilter,
            clientTypes: clientTypes,
            registrationTypes: registrationTypes,
            projectTypes: projectTypes,
          };
          filter = false;
          formLoading = false;
        });
      } else {
        extraFilter = {
          ...extraFilter,
        };
        filter = false;
        formLoading = false;
      }
    }
  };

  onMount(() => {
    // getClientDetail()
    // filter = false
  });

  let firstTime = true;
  const setFilter = (params) => {
    extraFilter = { ...params };
    getClientDetail();
  };

  const showDialog = getContext('showDialog');
</script>

<div class="d-flex h-100 w-100 p-3 flex-column">
  <div class="block-header mb-2">
    <div class="row align-items-center">
      <div class="col-md-12">
        <h2 class="page-title mb-2">Assign Tasks</h2>
      </div>
    </div>
    <AssignTaskFilter
      on:toggleFilter={(event) => {
        filter = false;
        formLoading = false;
        if (
          firstTime == false &&
          objCurrentList.checkSelectedTask()
          //&&  (extraFilter.unitId!=event.detail.unitId || extraFilter.clientId!=event.detail.clientId || extraFilter.taskSubType!=event.detail.taskSubType)
        ) {
          showDialog({
            type: 'confirm',
            title: 'Are you sure ?',
            message: 'Selected task and template will be removed',
            okFunc: () => {
              setFilter({ ...event.detail });
            },
          });
        } else {
          setFilter({ ...event.detail });
          firstTime = false;
        }
      }}
    />
  </div>
  {#if !filter && !formLoading}
    <div class="d-flex flex-row justify-content-end align-items-center mb-2"></div>

    <div class="page-content card-content bg-white h-100 p-0">
      <div class="h-100 d-flex flex-row">
        <div class=" h-100 d-flex flex-row w-100">
          <div class="page-content">
            <AssignTaskList
              bind:this={objCurrentList}
              extraFilter={extraFilter}
              clientTypes={clientTypes}
              registrationTypes={registrationTypes}
              projectTypes={projectTypes}
            />
          </div>
        </div>
      </div>
    </div>
  {/if}

  <!-- <div class="page-content h-100" id="assignTaskContent">
		  <AssignTask clientRegistration={true}/>
	  </div> -->
</div>

<style lang="scss">
  .assign-task-left {
    flex: 0 0 300px;
    max-width: 300px;
    background: rgba(205, 217, 233, 0.1);
  }
  .task-details {
    > ul {
      padding: 0px;
      margin: 0px;
      list-style: none;
    }
  }
  .nav-tabs {
    height: 51px;
    border-bottom: 1px solid $input-border-color;
    .nav-link {
      background: transparent;
      border: 0px;
      color: #000;
      text-align: center;
      padding: 15px 4px;
      svg {
        fill: #000;
      }
      &.active {
        color: $blue-color;
        position: relative;
        svg {
          fill: $blue-color;
        }
        &:after {
          content: '';
          position: absolute;
          left: 0px;
          bottom: 0px;
          width: 100%;
          height: 2px;
          background: $blue-color;
        }
      }
    }
  }
</style>
